import { parseJSONString } from '@pes-ui/utils';
const FAVORITE_RETAILERS_STORAGE_KEY = 'favorite-retailers';
const getKey = (countryLanguageCode) => `${FAVORITE_RETAILERS_STORAGE_KEY}-${countryLanguageCode}`;
const getFavoritesFromStorage = (countryLanguageCode) => {
  const key = getKey(countryLanguageCode);
  const favorites = parseJSONString(window.localStorage.getItem(key), null);
  return favorites || [];
};
const addFavoritesToStorage = (favorites, countryLanguageCode) => {
  const key = getKey(countryLanguageCode);
  window.localStorage.setItem(key, JSON.stringify(favorites));
};
const getLabelNumber = (label, labels) => {
  const { inStock, outOfStock, notAvailable } = labels;
  switch (label) {
    case inStock:
      return -1;
    case outOfStock:
      return 0;
    case notAvailable:
      return 1;
    default:
      return -2;
  }
};
const sortFavorites = (favorites, labels) => {
  return favorites.sort((a, b) => {
    const aNumber = getLabelNumber(a.stockLabel, labels);
    const bNumber = getLabelNumber(b.stockLabel, labels);
    return aNumber - bNumber;
  });
};
export const updateFavoritesInStorage = (distributor, countryLanguageCode) => {
  const storageFavorites = getFavoritesFromStorage(countryLanguageCode);
  const index = storageFavorites.findIndex((favorite) => favorite.id === distributor.id);
  if (index === -1) {
    storageFavorites.push(distributor);
    addFavoritesToStorage(storageFavorites, countryLanguageCode);
  }
  else {
    storageFavorites.splice(index, 1);
    addFavoritesToStorage(storageFavorites, countryLanguageCode);
  }
};
const getFavoritesList = (storageFavorites, distributors, notAvailableLabel) => storageFavorites.map((favorite) => {
  let item = distributors.find((distributor) => distributor.id === favorite.id);
  if (!item) {
    favorite.isAvailable = false;
    favorite.stockLabel = notAvailableLabel;
    favorite.buyUrl = favorite.retailerSite;
    favorite.price = null;
    item = favorite;
  }
  item.isFavorite = true;
  return item;
});
export const getSortedFavoritesList = (distributors, countryLanguageCode, labels) => {
  const storageFavorites = getFavoritesFromStorage(countryLanguageCode);
  const favoritesList = getFavoritesList(storageFavorites, distributors, labels.notAvailable);
  return sortFavorites(favoritesList, labels);
};
export const getFavoritesIds = (favoritesList) => (favoritesList
  ? favoritesList.map((favorite) => favorite.id)
  : []);
export const updateFavoriteStatus = (distributors, favoritesIds) => {
  distributors.forEach((distributor) => {
    distributor.isFavorite = favoritesIds.includes(distributor.id);
  });
};
